import _ from "lodash";
import { isDictionaryValid } from "./artefactValidators";

export const AUTO_ANNOTATION_DDBDATAFLOW_KEY = "ddbDataflow";
export const AUTO_ANNOTATION_RESTRICTED_FOR_PUBLICATION_KEY = "restrictedForPublication";
export const AUTO_ANNOTATION_FILE_PATH_KEY = "attachedFilePath";
export const AUTO_ANNOTATION_IS_MULTILINGUAL_KEY = "dcaT_IsMultilingual";
export const AUTO_ANNOTATION_HAVE_METADATA_KEY = "haveMetadata";
export const AUTO_ANNOTATION_CUSTOM_IS_PRESENTATIONAL_KEY = "customIsPresentational";
export const AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY = "linkedDataflowNode";
export const AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY = "dataflowCatalogType";
export const AUTO_ANNOTATION_DDB_CONTENT_CONSTRAINT_KEY = "ddbContentConstraint";

export const LAYOUT_ANNOTATION_DEFAULT_KEY = "default";
const LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_KEY = "layoutRow";
const LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_COLUMN_KEY = "layoutColumn";
const LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_SECTION_KEY = "layoutRowSection";
const LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_FILTER = "layoutFilter";
//duplicare tra cartesian e radial recuperando le annotations da nodesConfig nel backend
const LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM_CARTESIAN = "layoutChartPrimaryDimCartesian";
const LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM_CARTESIAN = "layoutChartSecondaryDimCartesian";
const LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER_CARTESIAN = "layoutChartFilterCartesian";
const LAYOUT_ANNOTATION_GRAPH_LOCKED_DIMS_CARTESIAN = 'layoutChartLockedDimsCartesian';

const LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM_RADIAL = "layoutChartPrimaryDimRadial";
const LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM_RADIAL = "layoutChartSecondaryDimRadial";
const LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER_RADIAL = "layoutChartFilterRadial";
const LAYOUT_ANNOTATION_GRAPH_LOCKED_DIMS_RADIAL = 'layoutChartLockedDimsRadial';

const LAYOUT_ANNOTATION_NOT_DISPLAYED_KEY = "notDisplayed";
const LAYOUT_ANNOTATION_ATTRIBUTE_AS_DIM_KEY = "attributeAsDim";
const LAYOUT_ANNOTATION_FULL_NAME_KEY = "fullName";
const LAYOUT_ANNOTATION_DATAFLOW_KEYWORDS_KEY = 'layoutDataflowKeywords';
const LAYOUT_ANNOTATION_CRITERIA_SELECTION_KEY = 'layoutCriteriaSelection';
const LAYOUT_ANNOTATION_ATTACHED_DATA_FILES_KEY = 'layoutAttachedDataFiles';
const LAYOUT_ANNOTATION_DEFAULT_PRESENTATION_KEY = 'layoutDefaultPresentation';
const LAYOUT_ANNOTATION_DECIMAL_SEPARATOR_KEY = 'layoutDecimalSeparator';
const LAYOUT_ANNOTATION_NUMBER_OF_DECIMALS_KEY = 'layoutNumberOfDecimals';
const LAYOUT_ANNOTATION_REFERENCE_METADATA_KEY = 'layoutReferenceMetadata';
const LAYOUT_ANNOTATION_EMPTY_CELL_PLACEHOLDER_KEY = 'layoutEmptyCellPlaceholder';
const LAYOUT_ANNOTATION_DATAFLOW_HIDDEN_KEY = 'layoutDataflowHidden';
const LAYOUT_ANNOTATION_DATAFLOW_NOTES_KEY = 'layoutDataflowNotes';
const LAYOUT_ANNOTATION_TERRITORIAL_DIMENSION_IDS_KEY = 'layoutTerritorialDimensionIds';
const LAYOUT_ANNOTATION_DATAFLOW_SOURCE_KEY = 'layoutDataflowSource';
const LAYOUT_ANNOTATION_TEMPORAL_DIM_ORDER = 'temporalDimOrder';
const LAYOUT_ANNOTATION_DISABLED_VIEWERS = 'disabledViewers';
const LAYOUT_ANNOTATION_AGGREGATE_CELLS = 'layoutAggregateCells';
const LAYOUT_ANNOTATION_TABLE_LOCKED_DIMS = 'tableLockedDims';
const LAYOUT_ANNOTATION_HCL_KEY = "hclReference";
const LAYOUT_ANNOTATION_ANTICIPATION_EXCEEDING_MAXNUM_RECORDS_KEY = 'anticipationExceedingMaxNumRecords';
const LAYOUT_ANNOTATION_DEFAULT_MAP_LAYOUT_FILTER = "layoutMapFilter"

export const LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER = 'LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATABROWSER';
export const LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER = 'LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_MODE_DATAEXPLORER';

export const TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE = "TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_RANGE";
export const TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS = "TIME_DIMENSION_DEFAULT_ANNOTATION_MODE_LAST_N_PERIODS";

export const DATAFLOW_CATALOG_TYPE_ONLY_FILE = "ONLY_FILE";

export const DATAFLOW_NON_READY_FOR_PRODUCTION = "nonReadyForProduction";
export const DATAFLOW_READY_FOR_PRODUCTION = "readyForProduction";

const LAYOUT_ANNOTATION_KEYS = [
  LAYOUT_ANNOTATION_DEFAULT_KEY,
  LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_KEY,
  LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_COLUMN_KEY,
  LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_SECTION_KEY,
  LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_FILTER,
  //cartesian and radial
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM_CARTESIAN,
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM_CARTESIAN,
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER_CARTESIAN,
  LAYOUT_ANNOTATION_GRAPH_LOCKED_DIMS_CARTESIAN,

  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM_RADIAL,
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM_RADIAL,
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER_RADIAL,
  LAYOUT_ANNOTATION_GRAPH_LOCKED_DIMS_RADIAL,

  LAYOUT_ANNOTATION_NOT_DISPLAYED_KEY,
  LAYOUT_ANNOTATION_ATTRIBUTE_AS_DIM_KEY,
  LAYOUT_ANNOTATION_FULL_NAME_KEY,
  LAYOUT_ANNOTATION_DATAFLOW_KEYWORDS_KEY,
  LAYOUT_ANNOTATION_CRITERIA_SELECTION_KEY,
  LAYOUT_ANNOTATION_ATTACHED_DATA_FILES_KEY,
  LAYOUT_ANNOTATION_DEFAULT_PRESENTATION_KEY,
  LAYOUT_ANNOTATION_DECIMAL_SEPARATOR_KEY,
  LAYOUT_ANNOTATION_NUMBER_OF_DECIMALS_KEY,
  LAYOUT_ANNOTATION_REFERENCE_METADATA_KEY,
  LAYOUT_ANNOTATION_EMPTY_CELL_PLACEHOLDER_KEY,
  LAYOUT_ANNOTATION_DATAFLOW_NOTES_KEY,
  LAYOUT_ANNOTATION_TERRITORIAL_DIMENSION_IDS_KEY,
  LAYOUT_ANNOTATION_DATAFLOW_SOURCE_KEY,
  LAYOUT_ANNOTATION_DATAFLOW_HIDDEN_KEY,
  LAYOUT_ANNOTATION_TEMPORAL_DIM_ORDER,
  LAYOUT_ANNOTATION_DISABLED_VIEWERS,
  LAYOUT_ANNOTATION_AGGREGATE_CELLS,
  LAYOUT_ANNOTATION_TABLE_LOCKED_DIMS,
  LAYOUT_ANNOTATION_HCL_KEY,
  LAYOUT_ANNOTATION_ANTICIPATION_EXCEEDING_MAXNUM_RECORDS_KEY,
  LAYOUT_ANNOTATION_DEFAULT_MAP_LAYOUT_FILTER,
  DATAFLOW_NON_READY_FOR_PRODUCTION,
  DATAFLOW_READY_FOR_PRODUCTION
];
export const CHART_LAYOUT_MODE = {
  cartesian: 'Cartesian',
  radial: 'Radial'
}
const chartLayoutMode = {
  "Cartesian": {
    "primaryDim": LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM_CARTESIAN,
    "secondaryDim": LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM_CARTESIAN,
    "filter": LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER_CARTESIAN,
    "graphDims": LAYOUT_ANNOTATION_GRAPH_LOCKED_DIMS_CARTESIAN,
  },
  "Radial": {
    "primaryDim": LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM_RADIAL,
    "secondaryDim": LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM_RADIAL,
    "filter": LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER_RADIAL,
    "graphDims": LAYOUT_ANNOTATION_GRAPH_LOCKED_DIMS_RADIAL,
  },
}

const CHART_LAYOUT_ANNOTATIONS = [
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM_CARTESIAN,
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM_CARTESIAN,
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER_CARTESIAN,
  LAYOUT_ANNOTATION_GRAPH_LOCKED_DIMS_CARTESIAN,
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_PRIMARY_DIM_RADIAL,
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_SECONDARY_DIM_RADIAL,
  LAYOUT_ANNOTATION_DEFAULT_CHART_LAYOUT_FILTER_RADIAL,
  LAYOUT_ANNOTATION_GRAPH_LOCKED_DIMS_RADIAL,
]

const getAnnotationTitle = (allAnnotations, annotationsConfig, key) => {
  let title = null;
  allAnnotations = allAnnotations || [];
  const annotationFromConfig = annotationsConfig[key];
  const annotationType = annotationFromConfig ? annotationFromConfig.type : null;
  if (annotationType) {
    const annotation = (allAnnotations
      .find((ann) => (ann && isStrCaseInsensitiveEquals(ann.type, annotationType))));
    title = annotation ? annotation.title : null
  }
  return title;
};

const getAnnotationText = (allAnnotations, annotationsConfig, key) => {
  let text = null;
  allAnnotations = allAnnotations || [];
  const annotationFromConfig = annotationsConfig[key];
  const annotationType = annotationFromConfig ? annotationFromConfig.type : null;
  if (annotationType) {
    const annotation = (allAnnotations
      .find((ann) => (ann && isStrCaseInsensitiveEquals(ann.type, annotationType))));
    text = annotation ? annotation.text : null
  }
  return text;
};
const getAnnotationTextWithoutProcess = (allAnnotations, annotationsConfig, key) => {
  const annotationText = getAnnotationText(allAnnotations, annotationsConfig, key);
  return annotationText || null;
};

const getAnnotationTitletWithoutProcess = (allAnnotations, annotationsConfig, key) => {
  const annotationTitle = getAnnotationTitle(allAnnotations, annotationsConfig, key);
  return annotationTitle || null;
};

const getAnnotationTitleWithSplit = (allAnnotations, annotationsConfig, key, splitStr) => {
  const annotationTitle = getAnnotationTitle(allAnnotations, annotationsConfig, key);
  return annotationTitle
    ? annotationTitle.split(splitStr)
    : [];
};
const getAnnotationsData = (allAnnotations, annotationsConfig, key) => {
  allAnnotations = allAnnotations || [];
  const annotationFromConfig = annotationsConfig[key];
  const annotationType = annotationFromConfig ? annotationFromConfig.type : null;
  const otherAnnotations = allAnnotations.filter((ann) => (ann && !isStrCaseInsensitiveEquals(ann.type, annotationType)));
  return (
    {
      annotation: annotationFromConfig,
      otherAnnotations: otherAnnotations
    }
  );
};
const getAnnotation = (annotationsConfig, allAnnotations, key) => {
  allAnnotations = allAnnotations || [];
  let annotation = null;
  const annotationFromConfig = annotationsConfig[key];
  if (annotationFromConfig) {
    annotation = allAnnotations.find((ann) => (ann && isStrCaseInsensitiveEquals(ann.type, annotationFromConfig.type)));
  }

  return annotation;
}

export const isStrCaseInsensitiveEquals = (str1, str2) => (str1 || "").toLowerCase() === (str2 || "").toLowerCase();

export function getGenericAnnotations(allAnnotations, customAnnotationsConfig, annotationsConfig) {

  allAnnotations = allAnnotations || [];
  customAnnotationsConfig = customAnnotationsConfig || [];

  const customAnnotationTypes = [];
  customAnnotationsConfig.forEach(({ annotations }) =>
    annotations.forEach((ann) => (ann && customAnnotationTypes.push((ann.name || "").toLowerCase()))));

  const layoutAnnotations = _.flatMap(_.pick(annotationsConfig, LAYOUT_ANNOTATION_KEYS));
  const layoutAnnotationTypes = layoutAnnotations.map(ann => (ann.type || "").toLowerCase());

  return allAnnotations.filter((ann) => (
    ann &&
    !customAnnotationTypes.includes((ann.type || "").toLowerCase()) &&
    !layoutAnnotationTypes.includes((ann.type || "").toLowerCase())));
}

export function getCustomAnnotationsTabsMap(allAnnotations, customAnnotationsConfig) {

  allAnnotations = allAnnotations || [];
  customAnnotationsConfig = customAnnotationsConfig || [];

  let res = {};

  customAnnotationsConfig.forEach(({ name: tabName, label, annotations }) => {
    res[tabName] = {
      label,
      annotations: {}
    };
    annotations.forEach(({ name: type }) =>
      res[tabName].annotations[type] = (allAnnotations.find(annot => isStrCaseInsensitiveEquals(annot.type, type)) || {}).text || null
    );
  });

  return res;
}

export function getCustomAnnotationsFromTabsMap(tabsMap) {

  let res = [];

  Object.keys(tabsMap).forEach(key =>
    Object.keys(tabsMap[key].annotations)
      .forEach(type => {
        if (tabsMap[key].annotations[type] &&
          _(tabsMap[key].annotations[type])
            .pickBy(val => val.length > 0)
            .keys()
            .value().length > 0
        ) {
          res.push({
            type,
            text: tabsMap[key].annotations[type]
          });
        }
      })
  );

  return res;
}

export function countCustomAnnotations(allAnnotations, customAnnotationsConfig, includeNotVisible) {

  allAnnotations = allAnnotations || [];
  customAnnotationsConfig = customAnnotationsConfig || [];

  const customAnnotationTypes = [];
  customAnnotationsConfig.forEach(({ annotations, isVisible }) => {
    if (isVisible || includeNotVisible) {
      annotations.forEach(({ name, isVisible }) => {
        if (isVisible || includeNotVisible) {
          customAnnotationTypes.push(name.toLowerCase())
        }
      });
    }
  });

  return allAnnotations.filter((ann) => customAnnotationTypes.includes((ann.type || "").toLowerCase())).length;
}

export function getLayoutAnnotations(allAnnotations, annotationsConfig) {

  allAnnotations = allAnnotations || [];

  const layoutAnnotations = _.flatMap(_.pick(annotationsConfig, LAYOUT_ANNOTATION_KEYS));
  const layoutAnnotationTypes = layoutAnnotations.map(annot => (annot.type || "").toLowerCase());

  return allAnnotations.filter((ann) => layoutAnnotationTypes.includes((ann.type || "").toLowerCase()));
}

export function countLayoutAnnotations(allAnnotations, annotationsConfig) {

  allAnnotations = allAnnotations || [];

  const layoutAnnotations = _.flatMap(_.pick(annotationsConfig, LAYOUT_ANNOTATION_KEYS));

  const layoutAnnotationTypes = layoutAnnotations.map(annot => (annot && (annot.type || "").toLowerCase()));

  return allAnnotations.filter((ann) => layoutAnnotationTypes.includes((ann.type || "").toLowerCase())).length;
}


export function hasLayoutAnnotationDefault(allAnnotations, annotationsConfig) {
  const annotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_DEFAULT_KEY);
  return annotation !== undefined;
}

export function setLayoutAnnotationDefaultForCodelist(allAnnotations, annotationsConfig, isDefault) {

  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DEFAULT_KEY);

  return isDefault
    ? ([
      ...data.otherAnnotations,
      {
        type: data.annotation.type,
        id: data.annotation.id,
        title: data.annotation.id
      }
    ])
    : data.otherAnnotations;
}

export function getLayoutAnnotationDefaultItems(allAnnotations, annotationsConfig) {

  const items = {};
  const annotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_DEFAULT_KEY);

  if (annotation) {
    const title = annotation.title || "";
    const splitRes = title.split(",");
    const normalizedSplitRes = splitRes.filter(val => val.length > 0).map(val => val.split("=")).filter(arr => arr[0].length > 0);
    normalizedSplitRes.forEach(split => {
      items[split[0]] =
        split[1]
          ? split[1].split("+").filter(val => val.length > 0)
          : [];
    });
  }


  return items;
}

export function setLayoutAnnotationDefaultItems(allAnnotations, annotationsConfig, defaultObj) {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DEFAULT_KEY);

  return Object.keys(defaultObj).length > 0
    ? ([
      ...data.otherAnnotations,
      {
        type: data.annotation.type,
        id: data.annotation.id,
        title: Object.keys(defaultObj).map(id =>
          id + (
            defaultObj[id].length > 0
              ? ("=" + defaultObj[id].join("+"))
              : ""
          )).join(",")
      }
    ])
    : data.otherAnnotations;
}

export function getLayoutAnnotationFullname(allAnnotations, annotationsConfig) {
  const annotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_FULL_NAME_KEY);
  return annotation ? annotation.text : null;
}

export function setLayoutAnnotationFullName(allAnnotations, annotationsConfig, fullName) {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_FULL_NAME_KEY);

  return _(fullName).pickBy(val => val.length > 0).keys().value().length > 0
    ? ([
      ...data.otherAnnotations,
      {
        type: data.annotation.type,
        id: data.annotation.id,
        // title: data.annotation.id,
        text: fullName
      }
    ])
    : data.otherAnnotations;
}

export function getLayoutAnnotationNotDisplayed(allAnnotations, annotationsConfig) {
  const annotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_NOT_DISPLAYED_KEY);
  const res = {};
  if (annotation) {
    const splitRes = (annotation.title || "").split(",");
    const normalizedSplitRes = splitRes.filter(val => val.length > 0)
      .map(val => val.split("="))
      .filter(arr => arr[0].length > 0);
    normalizedSplitRes.forEach(split => {
      res[split[0]] =
        split[1]
          ? split[1].split("+").filter(val => val.length > 0)
          : [];
    });
  }
  return res;
}

export function setLayoutAnnotationNotDisplayed(allAnnotations, annotationsConfig, notDisplayed) {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_NOT_DISPLAYED_KEY);

  return Object.keys(notDisplayed).length > 0
    ? ([
      ...data.otherAnnotations,
      {
        type: data.annotation.type,
        id: data.annotation.id,
        title: Object.keys(notDisplayed).map(id =>
          id + (
            notDisplayed[id].length > 0
              ? ("=" + notDisplayed[id].join("+"))
              : ""
          )).join(",")
      }
    ])
    : data.otherAnnotations;
}

export function getLayoutAnnotationAttributeAsDim(allAnnotations, annotationsConfig) {
  const annotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_ATTRIBUTE_AS_DIM_KEY);
  const res = {};
  if (annotation) {
    const splitRes = (annotation.title || "").split(",");
    const normalizedSplitRes = splitRes.filter(val => val.length > 0)
      .map(val => val.split("="))
      .filter(arr => arr[0].length > 0);
    normalizedSplitRes.forEach(split => {
      res[split[0]] =
        split[1]
          ? split[1].split("+").filter(val => val.length > 0)
          : [];
    });
  }
  return res;
}

export function setLayoutAnnotationAttributeAsDim(allAnnotations, annotationsConfig, attributeAsDim) {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_ATTRIBUTE_AS_DIM_KEY);
  return Object.keys(attributeAsDim).length > 0
    ? ([
      ...data.otherAnnotations,
      {
        type: data.annotation.type,
        id: data.annotation.id,
        title: Object.keys(attributeAsDim).map(id =>
          id + (
            attributeAsDim[id].length > 0
              ? ("=" + attributeAsDim[id].join("+"))
              : ""
          )).join(",")
      }
    ])
    : data.otherAnnotations;
}

export function getLayoutAnnotationDefaultTableLayout(allAnnotations, annotationsConfig) {
  const layoutRowAnnotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_KEY);
  const layoutColumnAnnotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_COLUMN_KEY);
  const layoutFilterAnnotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_FILTER);
  const layoutRowSectionAnnotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_SECTION_KEY);

  const rowSplitRes = layoutRowAnnotation ? (layoutRowAnnotation.title || "").split(",") : [];
  const columnSplitRes = layoutColumnAnnotation ? (layoutColumnAnnotation.title || "").split(",") : [];
  const filterSplitRes = layoutFilterAnnotation ? (layoutFilterAnnotation.title || "").split(",").map(e => e.split("=")[0]) : [];
  const rowSectionSplitRes = layoutRowSectionAnnotation ? (layoutRowSectionAnnotation.title || "").split(",") : [];
  const filterDefaultValuesSplitRes = layoutFilterAnnotation ? (layoutFilterAnnotation.title || "")
    .split(",").filter(e => e.includes("=")).reduce((acc, item) => {
      let [filterId, filterValue] = item.split("=");
      return { ...acc, [filterId]: filterValue };
    }, {})
    : {};

  return (rowSplitRes.length > 0 || columnSplitRes.length > 0 || filterSplitRes.length > 0 || rowSectionSplitRes.length > 0)
    ? ({
      row: rowSplitRes,
      column: columnSplitRes,
      filter: filterSplitRes,
      filterDefaultValues: filterDefaultValuesSplitRes,
      rowSection: rowSectionSplitRes,
    })
    : null;
}

export function setLayoutAnnotationDefaultTableLayout(allAnnotations, annotationsConfig, layout) {

  allAnnotations = allAnnotations || [];
  const layoutRowAnnotation = annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_KEY];
  const layoutColumnAnnotation = annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_COLUMN_KEY];
  const layoutFilterAnnotation = annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_FILTER];
  const layoutRowSectionAnnotation = annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_TABLE_LAYOUT_ROW_SECTION_KEY];
  const otherAnnotations = allAnnotations.filter((ann) => ann &&
    !isStrCaseInsensitiveEquals(ann.type, layoutRowAnnotation.type) &&
    !isStrCaseInsensitiveEquals(ann.type, layoutColumnAnnotation.type) &&
    !isStrCaseInsensitiveEquals(ann.type, layoutRowSectionAnnotation.type) &&
    !isStrCaseInsensitiveEquals(ann.type, layoutFilterAnnotation.type)
  );

  return otherAnnotations
    .concat(
      layout && layout.row.length > 0
        ? ([{
          type: layoutRowAnnotation.type,
          id: layoutRowAnnotation.id,
          title: layout.row.join(",")
        }])
        : []
    )
    .concat(
      layout && layout.column.length > 0
        ? ([{
          type: layoutColumnAnnotation.type,
          id: layoutColumnAnnotation.id,
          title: layout.column.join(",")
        }])
        : []
    )
    .concat(
      layout && layout.filter.length > 0
        ? ([{
          type: layoutFilterAnnotation.type,
          id: layoutFilterAnnotation.id,
          title: layout.filter.map(e => {
            if (layout.filterDefaultValues && layout.filterDefaultValues[e])
              return (e + "=" + layout.filterDefaultValues[e])
            else
              return e
          }).join(",")
        }])
        : []
    )
    .concat(
      layout && layout.rowSection.length > 0
        ? ([{
          type: layoutRowSectionAnnotation.type,
          id: layoutRowSectionAnnotation.id,
          title: layout.rowSection.join(",")
        }])
        : []
    );
}

export function getLayoutAnnotationDefaultChartLayout(allAnnotations, annotationsConfig, chartMode) {
  const data = chartLayoutMode[chartMode]
  const layoutPrimaryDimAnnotation = getAnnotation(annotationsConfig, allAnnotations, data["primaryDim"]);
  const layoutSecondaryDimAnnotation = getAnnotation(annotationsConfig, allAnnotations, data["secondaryDim"]);
  const layoutFiltersAnnotation = getAnnotation(annotationsConfig, allAnnotations, data["filter"]);

  const primaryDim = layoutPrimaryDimAnnotation ? layoutPrimaryDimAnnotation.title || "" : "";
  const secondaryDim = layoutSecondaryDimAnnotation ? layoutSecondaryDimAnnotation.title || "" : "";
  const filterSplitRes = layoutFiltersAnnotation ? (layoutFiltersAnnotation.title || "").split(",").map(e => e.split("=")[0]) : []
  const filterDefaultValuesSplitRes = layoutFiltersAnnotation ? (layoutFiltersAnnotation.title || "")
    .split(",").filter(e => e.includes("=")).reduce((acc, item) => {
      let [filterId, filterValue] = item.split("=");
      return { ...acc, [filterId]: filterValue };
    }, {})
    : {};

  return (primaryDim !== "" || secondaryDim !== "" || filterSplitRes.length > 0)
    ? ({
      primaryDim: [primaryDim],
      secondaryDim: [secondaryDim],
      filter: filterSplitRes,
      filterDefaultValues: filterDefaultValuesSplitRes
    })
    : null;
}

export function getAllChartLayoutAnnotations(allAnnotations, annotationsConfig) {
  return allAnnotations.filter(({ type }) =>
    CHART_LAYOUT_ANNOTATIONS.some((annotation) =>
      isStrCaseInsensitiveEquals(type, annotationsConfig[annotation].type)
    )
  )
}

export function setLayoutAnnotationDefaultChartLayout(allAnnotations, annotationsConfig, layout, chartMode) {
  allAnnotations = allAnnotations || [];

  if (!chartMode) {
    return allAnnotations.filter(({ type }) =>
      !CHART_LAYOUT_ANNOTATIONS.some((annotation) =>
        isStrCaseInsensitiveEquals(type, annotationsConfig[annotation].type)
      )
    )
  }

  const layoutPrimaryDimAnnotation = annotationsConfig[chartLayoutMode[chartMode].primaryDim];
  const layoutSecondaryDimAnnotation = annotationsConfig[chartLayoutMode[chartMode].secondaryDim];
  const layoutFilterAnnotation = annotationsConfig[chartLayoutMode[chartMode].filter];

  const otherAnnotations = allAnnotations.filter((ann) => ann &&
    !isStrCaseInsensitiveEquals(ann.type, layoutPrimaryDimAnnotation.type) &&
    !isStrCaseInsensitiveEquals(ann.type, layoutSecondaryDimAnnotation.type) &&
    !isStrCaseInsensitiveEquals(ann.type, layoutFilterAnnotation.type)
  );
  return otherAnnotations
    .concat(
      layout && layout.primaryDim && layout.primaryDim[0]
        ? ([{
          type: layoutPrimaryDimAnnotation.type,
          id: layoutPrimaryDimAnnotation.id,
          title: layout.primaryDim[0]
        }])
        : []
    )
    .concat(
      layout && layout.secondaryDim && layout.secondaryDim[0]
        ? ([{
          type: layoutSecondaryDimAnnotation.type,
          id: layoutSecondaryDimAnnotation.id,
          title: layout.secondaryDim[0]
        }])
        : []
    )
    .concat(
      layout && layout.filter && layout.filter[0]
        ? ([{
          type: layoutFilterAnnotation.type,
          id: layoutFilterAnnotation.id,
          title: layout.filter.map(e => {
            if (layout.filterDefaultValues && layout.filterDefaultValues[e])
              return (e + "=" + layout.filterDefaultValues[e])
            else
              return e
          }).join(",")
        }])
        : []
    );
}

export const getLayoutAnnotationDataflowKeywords = (allAnnotations, annotationsConfig) => {

  const annotationText = getAnnotationText(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DATAFLOW_KEYWORDS_KEY);

  if (annotationText !== null) {
    // {en: "k1+k2", it: "k3+k4"}
    return _(annotationText)
      .pickBy(val => val !== undefined && val !== null && val.length > 0)
      .mapValues(val => val.split("+"))
      .value();

  } else {
    return null;
  }
};

export const setLayoutAnnotationDataflowKeywords = (allAnnotations, annotationsConfig, dataflowKeywords) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DATAFLOW_KEYWORDS_KEY);

  let annotation = null;

  if (isDictionaryValid(dataflowKeywords)) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      // title: data.annotation.id,
      text: ""
    });

    // {en: "k1+k2", it: "k3+k4"}

    annotation.text = _(dataflowKeywords)
      .pickBy(val => val !== undefined && val !== null && val.length > 0)
      .mapValues(val => val.join("+"))
      .value();
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationAttachedDataFiles = (allAnnotations, annotationsConfig) => {

  const annotationText = getAnnotationText(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_ATTACHED_DATA_FILES_KEY);

  if (annotationText !== null) {

    return _(annotationText)
      .mapValues(val =>
        val.split("||").map(elem => {
          const elements = elem.split("|");
          const elementUri = decodeURI(elements[0]);
          const elementFormat = elements.length > 1 ? decodeURI(elements[1]) : null;
          return (
            {
              url: elementUri,
              format: elementFormat
            })
        }
        ))
      .value();
  } else {
    return null;
  }
};

export const setLayoutAnnotationAttachedDataFiles = (allAnnotations, annotationsConfig, attachedDataFiles) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_ATTACHED_DATA_FILES_KEY);

  let annotation = null;

  const normalizedAttachedDataFiles =
    _(attachedDataFiles)
      .pickBy(val =>
        val !== undefined &&
        val !== null
      )
      .mapValues(val =>
        val.filter(({ url, format }) =>
          url !== null && url.length > 0 // &&
          // format !== null && format.length > 0
        ))
      .pickBy(val => val.length > 0)
      .value();


  if (_(normalizedAttachedDataFiles).keys().value().length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      text:
        _(normalizedAttachedDataFiles)
          .mapValues(val =>
            val.map(({ url, format }) => {
              let text = encodeURI(url);
              if (format && format.length > 0) {
                text += `|${encodeURI(format)}`;
              }
              return (text);
            }).join("||")
          )
          .value()
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationCriteriaSelection = (allAnnotations, annotationsConfig) => {
  return getAnnotationTitletWithoutProcess(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_CRITERIA_SELECTION_KEY);
};

export const setLayoutAnnotationCriteriaSelection = (allAnnotations, annotationsConfig, criteriaSelection) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_CRITERIA_SELECTION_KEY);

  let annotation = null;

  if (criteriaSelection && criteriaSelection.length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: criteriaSelection
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationDecimalSeparator = (allAnnotations, annotationsConfig) => {
  return getAnnotationTitletWithoutProcess(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DECIMAL_SEPARATOR_KEY);
};

export const setLayoutAnnotationDecimalSeparator = (allAnnotations, annotationsConfig, decimalSeparator) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DECIMAL_SEPARATOR_KEY);

  let annotation = null;

  if (decimalSeparator && decimalSeparator.length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: decimalSeparator
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationNumberOfDecimals = (allAnnotations, annotationsConfig) => {
  return getAnnotationTitletWithoutProcess(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_NUMBER_OF_DECIMALS_KEY);
};

export const setLayoutAnnotationNumberOfDecimals = (allAnnotations, annotationsConfig, numberOfDecimals) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_NUMBER_OF_DECIMALS_KEY);

  let annotation = null;

  if (numberOfDecimals !== null) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: String(numberOfDecimals)
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationReferenceMetadata = (allAnnotations, annotationsConfig) => {
  return getAnnotationTextWithoutProcess(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_REFERENCE_METADATA_KEY);
};

export const setLayoutAnnotationReferenceMetadata = (allAnnotations, annotationsConfig, referenceMetadata) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_REFERENCE_METADATA_KEY);

  let annotation = null;

  if (referenceMetadata && _(referenceMetadata).pickBy(val => val.length > 0).keys().value().length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      // title: data.annotation.id,
      text: referenceMetadata
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationEmptyCellPlaceholder = (allAnnotations, annotationsConfig) => {
  return getAnnotationTitletWithoutProcess(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_EMPTY_CELL_PLACEHOLDER_KEY);
};

export const setLayoutAnnotationEmptyCellPlaceholder = (allAnnotations, annotationsConfig, emptyCellPlaceholder) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_EMPTY_CELL_PLACEHOLDER_KEY);

  let annotation = null;

  if (emptyCellPlaceholder && emptyCellPlaceholder.length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: emptyCellPlaceholder
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationDataflowNotes = (allAnnotations, annotationsConfig) => {
  return getAnnotationTextWithoutProcess(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DATAFLOW_NOTES_KEY);
};

export const setLayoutAnnotationDataflowNotes = (allAnnotations, annotationsConfig, dataflowNotes) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DATAFLOW_NOTES_KEY);

  let annotation = null;

  if (dataflowNotes && _(dataflowNotes).pickBy(val => val.length > 0).keys().value().length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      // title: data.annotation.id,
      text: dataflowNotes
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationDataflowSource = (allAnnotations, annotationsConfig) => {
  return getAnnotationTextWithoutProcess(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DATAFLOW_SOURCE_KEY);
};

export const setLayoutAnnotationDataflowSource = (allAnnotations, annotationsConfig, dataflowSource) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DATAFLOW_SOURCE_KEY);

  let annotation = null;

  if (dataflowSource && _(dataflowSource).pickBy(val => val.length > 0).keys().value().length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      // title: data.annotation.id,
      text: dataflowSource
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationTerritorialDimensionIds = (allAnnotations, annotationsConfig) => {

  const territorialDimensionIds = getAnnotationTitleWithSplit(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_TERRITORIAL_DIMENSION_IDS_KEY, "+");
  const layoutFilterAnnotation = getAnnotation(annotationsConfig, allAnnotations, LAYOUT_ANNOTATION_DEFAULT_MAP_LAYOUT_FILTER);

  const filterDefaultValuesSplitRes = layoutFilterAnnotation ? (layoutFilterAnnotation.title || "")
    .split(",").filter(e => e.includes("=")).reduce((acc, item) => {
      let [filterId, filterValue] = item.split("=");
      return { ...acc, [filterId]: filterValue };
    }, {})
    : {};

  return ({ territorialDimensionIds, filterDefaultValues: filterDefaultValuesSplitRes });

};

export const setLayoutAnnotationTerritorialDimensionIds = (allAnnotations, annotationsConfig, territorialDimensionIds, filterDefaultValues) => {

  const layoutTerritorialDimensionAnnotation = annotationsConfig[LAYOUT_ANNOTATION_TERRITORIAL_DIMENSION_IDS_KEY];
  const layoutFilterAnnotation = annotationsConfig[LAYOUT_ANNOTATION_DEFAULT_MAP_LAYOUT_FILTER];

  const otherAnnotations = allAnnotations.filter((ann) => ann &&
    !isStrCaseInsensitiveEquals(ann.type, layoutTerritorialDimensionAnnotation.type) &&
    !isStrCaseInsensitiveEquals(ann.type, layoutFilterAnnotation.type)
  );

  return otherAnnotations.concat(
    territorialDimensionIds && territorialDimensionIds[0] ?
      ([{
        id: layoutTerritorialDimensionAnnotation.id,
        type: layoutTerritorialDimensionAnnotation.type,
        title: territorialDimensionIds.join("+")
      }])
      : []
  )
    .concat(
      filterDefaultValues && Object.keys(filterDefaultValues).length > 0
        ? ([{
          type: layoutFilterAnnotation.type,
          id: layoutFilterAnnotation.id,
          title: Object.keys(filterDefaultValues).map(element => (element + "=" + filterDefaultValues[element])).join(",")
        }])
        : []
    )
}

export const getLayoutAnnotationDefaultPresentation = (allAnnotations, annotationsConfig) => {
  return getAnnotationTitletWithoutProcess(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DEFAULT_PRESENTATION_KEY);
};

export const setLayoutAnnotationDefaultPresentation = (allAnnotations, annotationsConfig, defaultPresentation) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DEFAULT_PRESENTATION_KEY);

  let annotation = null;

  if (defaultPresentation && defaultPresentation.length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: defaultPresentation
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const getLayoutAnnotationDataflowHidden = (allAnnotations, annotationsConfig) => {
  const annotation = annotationsConfig[LAYOUT_ANNOTATION_DATAFLOW_HIDDEN_KEY];
  return !!allAnnotations.find((ann) => (ann && isStrCaseInsensitiveEquals(ann.type, annotation.type)));
};

export const setLayoutAnnotationDataflowHidden = (allAnnotations, annotationsConfig, isHidden) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DATAFLOW_HIDDEN_KEY);

  let annotation = null;

  if (isHidden) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: data.annotation.id
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}

export const removeOrderAnnotation = (allAnnotations, itemsOrderAnnotationType) => {
  const annotations = (allAnnotations || []).filter((ann) => (ann && ann.type !== itemsOrderAnnotationType));
  return (annotations && annotations.length > 0)
    ? annotations
    : null
};

export const getLayoutAnnotationTemporalDimOrder = (allAnnotations, annotationsConfig) => {
  return getAnnotationTitletWithoutProcess(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_TEMPORAL_DIM_ORDER);
};

export const setLayoutAnnotationTemporalDimOrder = (allAnnotations, annotationsConfig, temporalDimOrder) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_TEMPORAL_DIM_ORDER);

  let annotation = null;

  if (temporalDimOrder !== null) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: temporalDimOrder
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
};

export const getLayoutAnnotationDisabledViewers = (allAnnotations, annotationsConfig) => {
  return getAnnotationTitleWithSplit(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DISABLED_VIEWERS, "|");
};

export const setLayoutAnnotationDisabledViewers = (allAnnotations, annotationsConfig, disabledViewers) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_DISABLED_VIEWERS);

  let annotation = null;

  if (disabledViewers !== null && disabledViewers.length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: disabledViewers.join("|")
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
};

export const getLayoutAnnotationAggregateCells = (allAnnotations, annotationsConfig) => {
  return getAnnotationTitle(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_AGGREGATE_CELLS);
};

export const setLayoutAnnotationAggregateCells = (allAnnotations, annotationsConfig, aggregateCells) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_AGGREGATE_CELLS);

  let annotation = null;

  if (aggregateCells !== null && aggregateCells.length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: aggregateCells
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
};

export const getLayoutAnnotationTableLockedDims = (allAnnotations, annotationsConfig) => {
  return getAnnotationTitleWithSplit(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_TABLE_LOCKED_DIMS, "|");
};

export const setLayoutAnnotationTableLockedDims = (allAnnotations, annotationsConfig, tableLockedDims) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_TABLE_LOCKED_DIMS);

  let annotation = null;

  if (tableLockedDims !== null && tableLockedDims.length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: tableLockedDims.join("|")
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
};

export const getLayoutAnnotationGraphLockedDims = (allAnnotations, annotationsConfig, chartMode) => {
  return getAnnotationTitleWithSplit(allAnnotations, annotationsConfig, chartLayoutMode[chartMode]["graphDims"], "|");
};

export const setLayoutAnnotationGraphLockedDims = (allAnnotations, annotationsConfig, graphLockedDims, chartMode) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, chartLayoutMode[chartMode].graphDims);

  let annotation = null;

  if (graphLockedDims !== null && graphLockedDims.length > 0) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type,
      title: graphLockedDims.join("|")
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
};


const getHclReference = (hclValueDef) => {
  const items = hclValueDef.split(':');
  const dimensionId = items[0];
  const hclAgency = items[1];
  const hclIdVersionHier = items[2];
  const idVersionItems = hclIdVersionHier.split('(');
  const hclId = idVersionItems[0];
  const hclVersionHier = idVersionItems[1];
  const hclVersionHierItems = hclVersionHier.split(')');
  const hclVersion = hclVersionHierItems[0];
  let hierId = "";
  if (hclVersionHierItems.length === 2) {
    hierId = hclVersionHierItems[1].split('.').pop();
  }

  return ({
    dimensionId: dimensionId,
    hclTriplet: { id: hclId, agencyID: hclAgency, version: hclVersion },
    hierId: hierId
  })

}

export const getHclReferenceValuesFromAnnotation = (allAnnotations, annotationsConfig) => {

  const annotationTitle = getAnnotationTitle(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_HCL_KEY);

  let hclReferenceValues = null;

  // COMP_ID2:HCL_AG2:HCL_ID2(HCL_VS2).HIER_ID2

  if (annotationTitle !== null) {
    const hclValuesArray = annotationTitle.split(',') || [];
    hclValuesArray.forEach(hclValueDef => {
      if (hclValueDef) {
        const hclReference = getHclReference(hclValueDef);
        if (hclReferenceValues === null) {
          hclReferenceValues = {};
        }
        hclReferenceValues[hclReference.dimensionId] = { hclTriplet: hclReference.hclTriplet, hierId: hclReference.hierId };
      }
    })
  };

  return hclReferenceValues;
};

export const setHclReferenceAnnotation = (allAnnotations, annotationsConfig, componentsWithHclRef) => {
  allAnnotations = allAnnotations || [];
  const annotationFromConfig = annotationsConfig[LAYOUT_ANNOTATION_HCL_KEY];
  const annotationType = annotationFromConfig ? annotationFromConfig.type : null;
  const otherAnnotations = allAnnotations.filter((ann) => (ann && !isStrCaseInsensitiveEquals(ann.type, annotationType)));
  let annotation = null;

  if (annotationFromConfig && annotationType && (componentsWithHclRef || []).length) {
    const hclReferencesArray = [];
    componentsWithHclRef.forEach(comp => {
      const hierId = (comp.hierId || "").length > 0 ? `.${comp.hierId.toUpperCase()}` : "";
      hclReferencesArray.push(`${comp.id}:${comp.hclTriplet.agencyID}:${comp.hclTriplet.id}(${comp.hclTriplet.version})${hierId}`)
    })
    annotation = ({
      id: annotationFromConfig.id,
      type: annotationType,
      title: hclReferencesArray.join(',')
    });
  }
  return annotation ? otherAnnotations.concat(annotation) : otherAnnotations;
};

export const getLayoutAnnotationAnticipationExceedingMaxNumRecords = (allAnnotations, annotationsConfig) => {
  const annotation = annotationsConfig[LAYOUT_ANNOTATION_ANTICIPATION_EXCEEDING_MAXNUM_RECORDS_KEY];
  return !!allAnnotations.find((ann) => (ann && isStrCaseInsensitiveEquals(ann.type, annotation.type)));
};

export const setLayoutAnnotationAnticipationExceedingMaxNumRecords = (allAnnotations, annotationsConfig, isChecked) => {
  const data = getAnnotationsData(allAnnotations, annotationsConfig, LAYOUT_ANNOTATION_ANTICIPATION_EXCEEDING_MAXNUM_RECORDS_KEY);

  let annotation = null;

  if (isChecked) {

    annotation = ({
      id: data.annotation.id,
      type: data.annotation.type
    });
  }

  return annotation !== null ? data.otherAnnotations.concat(annotation) : data.otherAnnotations;
}


export function contentConstraintHasDDBAnnotation(annotationsConfig, contentConstraint) {
  if (!contentConstraint) {
    return false;
  }
  const ccAnnotations = [...(contentConstraint.annotations || []), ...(contentConstraint.autoAnnotations || [])];
  const ddbAnnotationType = (annotationsConfig[AUTO_ANNOTATION_DDB_CONTENT_CONSTRAINT_KEY].type).toLowerCase();
  let ddbAnnotation = ccAnnotations.find((ann) => (ann && (ann.type || "").toLowerCase()) === ddbAnnotationType);
  return ddbAnnotation !== undefined;
}
